import { Component, Input } from "@angular/core";
import { Colors, Sizes, Types, Width } from "../types/status-tag.type";

@Component({
  selector: "ds-status-tag",
  templateUrl: "./ds-status-tag.component.html",
  styleUrls: ["./ds-status-tag.component.scss"],
})
export class DsStatusTagComponent {
  @Input() color: Colors = "primary";
  @Input() type: Types = "default";
  @Input() size: Sizes = "sm";
  @Input() label = "";
  @Input() icon = "";
  @Input() soft = false;
  @Input() dsIcon = "";
  @Input() width: Width = "content";
  @Input() fixedWidth = "200px";
  @Input() loader = false;

  constructor() {}
}
